import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const synopTutorial = (id, buttonText) => [
  {
    element: '.synop_shortcut',
    intro: 'Możesz utworzyć skrót.'
  },
  {
    element: '.synop_type',
    intro: `Tutaj możesz wybrać parametr synopyczny. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
